/**
 * 权限指令
 *
 * 用法：
 * - v-permission="['admin']" - 需要 admin 角色
 * - v-permission="'system:user:add'" - 需要指定权限
 * - v-permission="['system:user:add', 'system:user:edit']" - 需要任意一个权限
 */
import type { Directive, DirectiveBinding } from 'vue'
import { useUserStore } from '@/stores/user'

/**
 * 检查权限
 */
function checkPermission(el: HTMLElement, binding: DirectiveBinding) {
  const { value } = binding
  const userStore = useUserStore()

  if (value) {
    const permissions = userStore.permissions
    const roles = userStore.roles

    // 超级管理员拥有所有权限
    if (permissions.includes('*:*:*') || roles.includes('admin')) {
      return
    }

    let hasPermission = false

    if (Array.isArray(value)) {
      // 数组：检查是否有任意一个权限/角色
      hasPermission = value.some(
        (item) => permissions.includes(item) || roles.includes(item)
      )
    } else if (typeof value === 'string') {
      // 字符串：检查单个权限/角色
      hasPermission = permissions.includes(value) || roles.includes(value)
    }

    // 没有权限，移除元素
    if (!hasPermission) {
      el.parentNode?.removeChild(el)
    }
  } else {
    // 没有指定权限要求，抛出错误
    throw new Error('Permission directive requires a value')
  }
}

/**
 * 权限指令定义
 */
export const permission: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  },
  updated(el: HTMLElement, binding: DirectiveBinding) {
    checkPermission(el, binding)
  },
}

export default permission
